import { AppThunk } from '../../../store/rootReducer';
import * as navigationActions from '../actions/navigation.actions';
import { activeSelector } from '../selectors/navigation.selectors';

export const stopNavigation = (): AppThunk => async (dispatch, getState) => {
  const navigationActive = activeSelector(getState());

  if (navigationActive) {
    dispatch(navigationActions.stop({ meta: { history: false } }));
  }
};
